<div class="source-display">
  <img [src]="'svg/widgets-logo.svg' | assetVersion" />
  <div class="source-label">
    {{source}}
  </div>
  <div class="source-divider">|</div>
  <div class="source-name">
    {{name}}
  </div>
</div>
